module.exports = __webpack_public_path__ + "hero-next-992-8bd21db80366dcde89c9669f182b714e.bundle.png";